import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

import { WaitlistForm } from './WaitlistForm'

const fadeInUp = {
  initial: { opacity: 0, y: 18 },
  animate: { opacity: 1, y: 0 },
}

export function ComingSoonHero() {
  const { t } = useTranslation()

  return (
    <section
      id="library"
      className="flex min-h-[80svh] items-center px-5 pb-14 pt-14 md:px-8 md:pb-20 md:pt-20"
    >
      <div className="mx-auto w-full max-w-[1280px]">
        <div className="mx-auto max-w-4xl text-center">
          <motion.p
            initial={fadeInUp.initial}
            animate={fadeInUp.animate}
            transition={{ duration: 0.35 }}
            className="inline-flex rounded-full bg-[var(--color-surface-container-low)] px-4 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-[var(--color-on-surface-variant)]"
          >
            {t('comingSoon.hero.badge')}
          </motion.p>

          <motion.h1
            initial={fadeInUp.initial}
            animate={fadeInUp.animate}
            transition={{ duration: 0.4, delay: 0.05 }}
            className="mt-8 text-[2.75rem] font-bold leading-[1.05] tracking-[-0.02em] text-[var(--color-on-surface)] md:text-7xl"
          >
            {t('comingSoon.hero.titleMain')}{' '}
            <span className="text-[var(--color-on-surface-variant)]/30">
              {t('comingSoon.hero.titleAccent')}
            </span>
          </motion.h1>

          <motion.h2
            initial={fadeInUp.initial}
            animate={fadeInUp.animate}
            transition={{ duration: 0.4, delay: 0.1 }}
            className="mt-3 text-3xl font-medium tracking-[-0.01em] text-[var(--color-on-surface-variant)] md:text-5xl"
          >
            {t('comingSoon.hero.subtitle')}
          </motion.h2>

          <motion.p
            initial={fadeInUp.initial}
            animate={fadeInUp.animate}
            transition={{ duration: 0.45, delay: 0.15 }}
            className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-[var(--color-on-surface-variant)]"
          >
            {t('comingSoon.hero.description')}
          </motion.p>

          <motion.div
            initial={fadeInUp.initial}
            animate={fadeInUp.animate}
            transition={{ duration: 0.45, delay: 0.2 }}
          >
            <WaitlistForm />
          </motion.div>
        </div>
      </div>
    </section>
  )
}
